import palette from './palette';
import { BORDER_RADIUS } from './shape';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    body3: React.CSSProperties;
    body4: React.CSSProperties;
    body5: React.CSSProperties;
    greyTag?: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    body3?: React.CSSProperties;
    body4?: React.CSSProperties;
    body5?: React.CSSProperties;
    greyTag?: React.CSSProperties;
  }
}
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    body3: true;
    body4: true;
    body5: true;
    greyTag: true;
  }
}

const DEFAULT_FONT = ['Roboto'].join(',');

const tag = {
  fontSize: '10px',
  fontWeight: 400,
  lineHeight: 'normal',
  color: palette.common.white,
  padding: '2px 4px',
  borderRadius: BORDER_RADIUS,
  display: 'inline-block',
  marginTop: 'auto',
};

const typography = {
  fontFamily: DEFAULT_FONT,
  h6: {
    color: palette.common.black,
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '2%',
    lineHeight: 1.2,
  },
  h5: {
    fontSize: '14px',
    color: palette.common.black,
    fontWeight: 500,
    letterSpacing: '2%',
  },
  h4: {
    fontSize: '16px',
    color: palette.common.black,
    fontWeight: 500,
  },
  h3: {
    fontSize: '20px',
    color: palette.common.black,
    fontWeight: 500,
  },
  h2: {
    fontSize: '22px',
    color: palette.common.black,
    fontWeight: 500,
    marginBottom: '10px',
  },
  h1: {
    fontSize: '26px',
    color: palette.common.black,
    fontWeight: 500,
  },
  body1: {
    fontSize: '16px',
    fontWeight: 400,
  },
  body2: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.2,
  },
  body3: {
    fontSize: '12px',
    fontWeight: 400,
  },
  body4: {
    fontSize: '10px',
    fontWeight: 400,
  },
  body5: {
    fontSize: '8px',
    fontWeight: 400,
  },
  greyTag: { ...tag, background: palette.grey[800] },
};
export default typography;
